/**
 * @generated SignedSource<<8c5695a7b7f5b8627f40713781ee65e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleCheck_taskCheck$data = {
  readonly id: string;
  readonly occasions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly occasion: {
          readonly endAt: string;
          readonly id: string;
          readonly sequenceNumber: number;
          readonly startAt: string;
        };
        readonly taskExecutions: ReadonlyArray<{
          readonly checkValue: TaskSentiment | null;
          readonly id: string;
          readonly sectionId: string;
          readonly " $fragmentSpreads": FragmentRefs<"SingleTaskInProgressCheck_taskExecutionCheck" | "WidgetTaskSingleCheckSmallInProgress_taskExecutions">;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleCheck_taskCheckOccasion">;
      };
    }>;
  };
  readonly routine: {
    readonly id: string;
    readonly title: string;
  };
  readonly title: string;
  readonly " $fragmentType": "WidgetTaskSingleCheck_taskCheck";
};
export type WidgetTaskSingleCheck_taskCheck$key = {
  readonly " $data"?: WidgetTaskSingleCheck_taskCheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleCheck_taskCheck">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskSingleCheck_taskCheck",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "TaskCheckOccasionConnection",
      "kind": "LinkedField",
      "name": "occasions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskCheckOccasionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskCheckOccasion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetTaskSingleCheck_taskCheckOccasion"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskExecutionCheck",
                  "kind": "LinkedField",
                  "name": "taskExecutions",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "checkValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sectionId",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "WidgetTaskSingleCheckSmallInProgress_taskExecutions"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SingleTaskInProgressCheck_taskExecutionCheck"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineOccasion",
                  "kind": "LinkedField",
                  "name": "occasion",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sequenceNumber",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "occasions(first:8)"
    }
  ],
  "type": "TaskCheck",
  "abstractKey": null
};
})();

(node as any).hash = "ad74bb51589ada7669d9378389632661";

export default node;
